import type { DpsMiniAppBackendStep } from "@gameApp/api/types/DpsMiniAppBackend";
import { MINUTE_IN_MS } from "@gameApp/constants";

const THREE_SECONDS_IN_MS = 3000;

export function whitelistStepsRefetchIntervalGet(
  steps: DpsMiniAppBackendStep[],
  shouldPauseRefetch?: boolean,
): number | null {
  if (shouldPauseRefetch) {
    return null;
  }

  const quest = steps.flatMap((item) => item.quests);
  const hasValidating = quest.some((item) => item.status === "VALIDATING");
  if (hasValidating) {
    return THREE_SECONDS_IN_MS;
  }

  return MINUTE_IN_MS;
}
